import { createCompNode, themeRefs } from '@wix/thunderbolt-catharsis'
import { EMPTY_ARRAY } from '../../../utils/constants'
import { extractFontFamiliesFromCssProperties } from '@wix/thunderbolt-becky-root'
import type { FeatureRefs } from '../../cssFeatures.types'
import type { Component, InnerElementStyle } from '@wix/thunderbolt-becky-types'

const extractFontFamiliesFromStyles = (styles: { [id: string]: InnerElementStyle }): Array<string> => {
	const fontFamilies: Array<string> = []

	const traverseStyleElement = (styleElement: any): void => {
		if (!styleElement || typeof styleElement !== 'object') {
			return
		}

		// If this element has cssProperties, extract font families from it
		if (styleElement.cssProperties) {
			const elementFontFamilies = extractFontFamiliesFromCssProperties(styleElement.cssProperties)
			fontFamilies.push(...elementFontFamilies)
		}

		// Recursively traverse all properties to find nested styles
		for (const [key, value] of Object.entries(styleElement)) {
			if (key !== 'cssProperties') { // Skip cssProperties as we already processed it
				traverseStyleElement(value)
			}
		}
	}

	traverseStyleElement(styles)

	return fontFamilies
}

export const innerElementsStyleFontFamilies = {
	predicate: () => true,
	compNode: createCompNode({
		getDependencies: (component: Component, refs: FeatureRefs<'fontFaces'>) => ({
			innerElementsStyles: refs.innerElementsStyles(component),
		}),
		toViewItem: (__, { innerElementsStyles }) => {
			if (!innerElementsStyles) {
				return EMPTY_ARRAY
			}
			return extractFontFamiliesFromStyles(innerElementsStyles)
		},
	}),
}
